import { useEffect } from "react";

import { useContentSelectors } from "../store/content/content.selectors";

import { useDispatchedActions } from "./use-dispatch-actions";

export const useMenuProxy = lang => {
  const { menuProxies } = useContentSelectors();

  const { getProxiesMenu } = useDispatchedActions();

  useEffect(() => {
    if (!menuProxies.length) {
      getProxiesMenu(lang);
    }
    // eslint-disable-next-line
  }, [menuProxies.length, lang]);
};
